import { render, staticRenderFns } from "./DropZoneV20Component.vue?vue&type=template&id=06aa3362&scoped=true"
import script from "./DropZoneV20Component.vue?vue&type=script&lang=js"
export * from "./DropZoneV20Component.vue?vue&type=script&lang=js"
import style0 from "./DropZoneV20Component.vue?vue&type=style&index=0&id=06aa3362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aa3362",
  null
  
)

export default component.exports